export const css = {
	oneaction: '_1U4vaM6t',
	' _key': 'certwise-theme/certwise/quiz-widgets/pretest-review'
};

export default css;
